
import { useState, useEffect } from "react";
import { Candidate } from "@/types/candidate";
import { fetchCandidatesFromDB } from "./fetch-candidates";
import { UseCandidatesReturnType } from "./types";

export const useCandidates = (): UseCandidatesReturnType => {
  const [candidates, setCandidates] = useState<Candidate[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchCandidates = async () => {
    try {
      setIsLoading(true);
      const data = await fetchCandidatesFromDB();
      setCandidates(data);
    } finally {
      setIsLoading(false);
    }
  };

  // Initial fetch
  useEffect(() => {
    fetchCandidates();
  }, []);

  return {
    candidates,
    setCandidates,
    isLoading,
    fetchCandidates
  };
};
